import React from "react";

// Official SnapPay logo (icon + wordmark combined image).
export default function Logo({ className = "h-8" }) {
  return (
    <img
      src="/brand/logo-snappay.jpg"
      alt="SnapPay"
      className={`${className} w-auto select-none`}
      draggable={false}
    />
  );
}
